import type { Props } from '.'

export type Raw = {
  acfFcLayout: 'simple_cta'
  simpleCta: Props
}

export type Parsed = {
  name: 'SimpleCTA'
  isFullWidth: boolean
  props: Props
}

export function parser(rawComponent: Raw): Parsed {
  return {
    name: 'SimpleCTA',
    isFullWidth: true,
    props: rawComponent.simpleCta,
  }
}
